<template>
    <div
        v-if="show"
        class="fixed inset-0 z-50 flex items-center justify-center"
    >
        <div
            class="absolute inset-0 bg-slate-900/50"
            @click="$emit('update:show', false)"
        ></div>
        <div
            class="relative bg-white dark:bg-slate-800 rounded-lg shadow-lg w-full max-w-sm md:max-w-md mx-4 p-6"
        >
            <div class="flex items-center justify-between mb-4">
                <h3 class="text-xl font-medium text-slate-900 dark:text-slate-100">
                    Delete payment method
                </h3>
                <button
                    class="p-2 rounded hover:bg-slate-100 dark:hover:bg-slate-700 dark:bg-slate-700 transition-colors"
                    @click="$emit('update:show', false)"
                >
                    <Icon icon="close" class="w-5 h-5 text-slate-500 dark:text-slate-400" />
                </button>
            </div>
            <p class="text-sm text-slate-500 dark:text-slate-400 mb-6">
                Are you sure you want to delete
                <strong>
                    {{ cardBrandLabel(card?.card?.brand) }}
                    ({{ card?.card?.last4 }})
                </strong>
                ? This action cannot be undone.
            </p>
            <div class="flex justify-end gap-3">
                <button
                    class="px-4 py-2.5 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm font-medium text-slate-900 dark:text-slate-100 rounded shadow-sm hover:bg-slate-50 dark:hover:bg-slate-700 dark:bg-slate-900/40 transition-colors"
                    @click="$emit('update:show', false)"
                >
                    Cancel
                </button>
                <button
                    class="px-4 py-2.5 bg-red-500 text-sm font-medium text-white rounded shadow-sm hover:bg-red-600 transition-colors disabled:opacity-50"
                    :disabled="deleteCardProcessing"
                    @click="handleDeleteCard"
                >
                    {{ deleteCardProcessing ? 'Deleting...' : 'Delete' }}
                </button>
            </div>
            <div
                v-if="deleteCardError"
                class="text-red-500 text-sm mt-3"
            >
                {{ deleteCardError }}
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import Icon from '@/components/ui/icon/icon.vue';

const props = defineProps({
    show: {
        type: Boolean,
        default: false,
    },
    card: {
        type: Object,
        default: null,
    },
});

const emit = defineEmits(['update:show', 'card-deleted']);

const deleteCardProcessing = ref(false);
const deleteCardError = ref('');

watch(
    () => props.show,
    (val) => {
        if (val) {
            deleteCardError.value = '';
        }
    }
);

const cardBrandLabel = (brand) => {
    if (!brand) return 'Card';
    const labels = {
        visa: 'Visa',
        mastercard: 'Mastercard',
        amex: 'Amex',
        discover: 'Discover',
        diners: 'Diners',
        jcb: 'JCB',
        unionpay: 'UnionPay',
    };
    return (
        labels[brand.toLowerCase()] ||
        brand.charAt(0).toUpperCase() + brand.slice(1)
    );
};

const handleDeleteCard = async () => {
    if (!props.card) return;
    deleteCardProcessing.value = true;
    deleteCardError.value = '';
    try {
        await ApiService.apiCall(
            `/travel-plus/payment-method/${props.card.id}`,
            'delete'
        );
        emit('card-deleted', props.card.id);
        emit('update:show', false);
    } catch (e) {
        deleteCardError.value =
            e?.response?.data?.message ||
            'Something went wrong. Please try again.';
    } finally {
        deleteCardProcessing.value = false;
    }
};
</script>
